var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _path, _circle, _g, _circle2, _g2, _circle3, _g3, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoSimple(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 78,
    viewBox: "0 0 63 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 10.4775,
    y1: 47.2617,
    x2: 55.1451,
    y2: 47.2617,
    stroke: "#D7B377"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 11.5752,
    y1: 49.5195,
    x2: 41.0309,
    y2: 49.5195,
    stroke: "#D7B377"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 11.5752,
    y1: 52.1992,
    x2: 31.0159,
    y2: 52.1992,
    stroke: "#D7B377"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 11.5752,
    y1: 55.3242,
    x2: 24.3884,
    y2: 55.3242,
    stroke: "#D7B377"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 11.5752,
    y1: 58.8906,
    x2: 20.0437,
    y2: 58.8906,
    stroke: "#D7B377"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 11.5752,
    y1: 62.9102,
    x2: 17.1718,
    y2: 62.9102,
    stroke: "#D7B377"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 11.5752,
    y1: 67.3711,
    x2: 15.2572,
    y2: 67.3711,
    stroke: "#D7B377"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 11.5752,
    y1: 72.2812,
    x2: 14.0053,
    y2: 72.2812,
    stroke: "#D7B377"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.915 13.9219L31.6797 40.2555L44.4367 47.4437",
    stroke: "#D7B377"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1527_81",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 14,
    width: 45,
    height: 45
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.161,
    cy: 36.9071,
    r: 21.536,
    stroke: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1527_81)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.4951,
    y: 14.8711,
    width: 21.757,
    height: 21.757,
    fill: "#D7B377"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1527_81",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 14,
    width: 45,
    height: 45
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.1634,
    cy: 36.9103,
    r: 21.536,
    transform: "rotate(30 31.1634 36.9103)",
    stroke: "black"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1527_81)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 42.4697,
    y: 17.9922,
    width: 21.757,
    height: 21.757,
    transform: "rotate(30 42.4697 17.9922)",
    fill: "#D7B377"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1527_81",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 14,
    width: 45,
    height: 45
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.1636,
    cy: 36.9102,
    r: 21.536,
    transform: "rotate(-45 31.1636 36.9102)",
    stroke: "black"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1527_81)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.8213,
    y: 21.0938,
    width: 21.757,
    height: 21.757,
    transform: "rotate(-45 15.8213 21.0938)",
    fill: "#D7B377"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.9717,
    y: 0.933594,
    width: 44.2376,
    height: 75.6696,
    stroke: "#D7B377"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSimple);
export default __webpack_public_path__ + "static/media/logo-simple.2d6f0761fbfc7d758bdee6c2c46f1f61.svg";
export { ForwardRef as ReactComponent };